var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            [
              _c("address-field-group", {
                ref: "addressFieldComponent",
                attrs: {
                  line1: _vm.applicantAddress.line1,
                  line2: _vm.applicantAddress.line2,
                  "unit-number": _vm.applicantAddress["unit-number"],
                  province: _vm.applicantAddress.province,
                  city: _vm.applicantAddress.city,
                  "postal-code": _vm.applicantAddress["postal-code"],
                  "street-direction": _vm.applicantAddress["street-direction"],
                  "street-name": _vm.applicantAddress["street-name"],
                  "street-number": _vm.applicantAddress["street-number"],
                  "street-type": _vm.applicantAddress["street-type"],
                  validator: _vm.v$.addresses,
                  "show-required-indicator": _vm.showRequiredIndicator,
                  label: _vm.multipleAddresses
                    ? ""
                    : _vm.$t("application-form.current-address"),
                },
                on: {
                  "update:line1": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "line1", $event)
                  },
                  "update:line2": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "line2", $event)
                  },
                  "update:unitNumber": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "unit-number", $event)
                  },
                  "update:unit-number": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "unit-number", $event)
                  },
                  "update:province": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "province", $event)
                  },
                  "update:city": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "city", $event)
                  },
                  "update:postalCode": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "postal-code", $event)
                  },
                  "update:postal-code": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "postal-code", $event)
                  },
                  "update:streetDirection": function ($event) {
                    return _vm.$set(
                      _vm.applicantAddress,
                      "street-direction",
                      $event
                    )
                  },
                  "update:street-direction": function ($event) {
                    return _vm.$set(
                      _vm.applicantAddress,
                      "street-direction",
                      $event
                    )
                  },
                  "update:streetName": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "street-name", $event)
                  },
                  "update:street-name": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "street-name", $event)
                  },
                  "update:streetNumber": function ($event) {
                    return _vm.$set(
                      _vm.applicantAddress,
                      "street-number",
                      $event
                    )
                  },
                  "update:street-number": function ($event) {
                    return _vm.$set(
                      _vm.applicantAddress,
                      "street-number",
                      $event
                    )
                  },
                  "update:streetType": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "street-type", $event)
                  },
                  "update:street-type": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "street-type", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.applicants.timeAtAddress"
                        )
                      ) +
                      "\n        "
                  ),
                  _vm.showRequiredIndicator
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("time-at-field-group", {
                attrs: {
                  value: _vm.applicantAddress["time-at"],
                  validator: _vm.v$.addresses["time-at"],
                  "has-warning": _vm.showTimeWarning,
                  "warning-message": _vm.$t(
                    "form-validations.total36MonthsResidences"
                  ),
                },
                on: {
                  "update:value": function ($event) {
                    return _vm.$set(_vm.applicantAddress, "time-at", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }